import styled from "styled-components";

// class 命名禁區：Image360 用 document.querySelectorAll(".imgContainer") / (".img360") 做全文件掃描，
// 這裡若撞名會讓主圖被一起 display:none，整個畫面空白。所以一律用 menu* 前綴。
export const StyledScanViewerTagMenu = styled.div`
  position: fixed;
  /* 左上控制按鈕群（兩顆 40px + 12px 間距，自 top:24 起算）下方 */
  top: 128px;
  left: 24px;
  width: min(280px, calc(100% - 48px));
  max-height: calc(100vh - 152px);
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  /* 壓過 viewer 其餘 chrome 的 99999，但要低於 ScanViewerTag 手機版全螢幕面板的 9999999 */
  z-index: 100000;

  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
  transform: ${({ $open }) => ($open ? "translateX(0)" : "translateX(-8px)")};
  transition:
    opacity 0.15s ease,
    transform 0.15s ease,
    visibility 0.15s;

  /* 拖曳旋轉時讓滑鼠穿透抽屜。
     不這樣做的話，滑鼠一移到抽屜上方就會觸發 Image360 的 onMouseLeave（= handleMouseUp），
     拖曳會在半路直接斷掉 —— 抽屜寬 280px，往左拖很容易掃過去。 */
  ${({ $dragging }) => $dragging && "pointer-events: none;"}

  /* fullscreen 模式下圖片貼齊畫面、沒有留白，抽屜必定壓在照片上，縮窄一點少擋一些 */
  ${({ $fullscreen }) => $fullscreen && "width: min(240px, calc(100% - 48px));"}

  .menuHeader {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px 10px 14px;
    border-bottom: 1px solid #ececec;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.02em;
    color: #333333;
  }

  .menuClose {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 4px;
    background: transparent;
    color: #666666;
    cursor: pointer;

    > svg {
      width: 18px;
      height: 18px;
    }

    &:hover {
      background: #f1f1f1;
    }
  }

  .menuList {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    /* 清單捲到底時不要把整頁一起帶著捲 */
    overscroll-behavior: contain;
    list-style: none;
    margin: 0;
    padding: 4px 0;

    /* 整個滾動條 */
    &::-webkit-scrollbar {
      width: 7px;
    }
    /* 滾動條軌道 */
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
    /* 滾動條滑塊 */
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background: rgba(0, 0, 0, 0.2);
    }
  }

  .menuItem {
    width: 100%;
    display: flex;
    align-items: center;
    column-gap: 10px;
    padding: 8px 12px;
    background: transparent;
    /* 目前畫面上的標籤會把這條邊染成橘色，所以每一列都先留好位置避免文字位移 */
    border-left: 3px solid transparent;
    text-align: left;
    cursor: pointer;

    &:hover {
      background: #f5f5f5;
    }

    /* 這個標籤就在目前這張畫面上 */
    &[data-current="true"] {
      border-left-color: rgba(255, 112, 67, 0.9);
      background: rgba(255, 112, 67, 0.08);
    }
  }

  .menuBadge {
    flex: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    /* 與 ScanViewerTag 的 tagBadge 同色，讓清單編號與畫面上的 marker 對得起來 */
    background: rgba(255, 112, 67, 0.9);
    color: #ffffff;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .menuTitle {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.02em;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .menuThumbnail {
    flex: none;
    width: 40px;
    height: 40px;
    border-radius: 4px;
    background: #f1f1f1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    > img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  @media all and (max-width: 414px) {
    top: 120px;
    left: 16px;
    width: min(72vw, 260px);
    /* 手機上不要吃掉整個畫面高度，物件本身還要看得到 */
    max-height: min(calc(100vh - 144px), 320px);
  }
`;
